import { buttonSizes, buttonVariants, modalSizes } from '@/components/shared';
import { Modal } from './Modal';
import register from './register';

register(Modal, {
	sizes: modalSizes,
	buttonVariants: buttonVariants,
	buttonSizes: buttonSizes,
	defaultSize: 'md',
	defaultButtonVariant: 'primary',
	defaultButtonSize: 'md',
});
